/**
 * useEffectiveTime
 * Hook that provides the effective "now" time, using server time when
 * time manipulation is enabled, or client time otherwise.
 */
import { useMemo } from 'react';
import { useFeature, Features } from '@billda/features-ui';
import { useGetCurrentTime } from './useTimeManipulation';

interface UseEffectiveTimeResult {
  effectiveNow: Date;
  isManipulated: boolean;
  isLoading: boolean;
}

export function useEffectiveTime(): UseEffectiveTimeResult {
  const isTimeManipEnabled = useFeature(
    Features.Debug.IsTimeManipulationEnabled
  );
  const { data: timeData, isLoading } = useGetCurrentTime({
    autoRefresh: isTimeManipEnabled,
  });

  const effectiveNow = useMemo(() => {
    if (
      isTimeManipEnabled &&
      timeData?.isManipulated &&
      timeData?.currentTime
    ) {
      return new Date(timeData.currentTime);
    }
    return new Date();
  }, [isTimeManipEnabled, timeData?.isManipulated, timeData?.currentTime]);

  return {
    effectiveNow,
    isManipulated: isTimeManipEnabled && (timeData?.isManipulated ?? false),
    isLoading,
  };
}
